import { ReactElement } from 'react'
import { I18n } from 'common'
import styled from 'styled-components'

interface CommonStepInfoI {
  orderNumber?: string
  orderDate?: string
  shippingId?: string
  shipmentNumber?: number
}

const CommonStepInfo = (props: CommonStepInfoI): ReactElement => {
  const { orderNumber, orderDate, shippingId, shipmentNumber } = props

  return (
    <Wrapper>
      <Flex>
        <Field>
          <I18n name="orderNumber" />:
        </Field>
        <Value>#{orderNumber}</Value>
      </Flex>
      <Flex>
        <Field>
          <I18n name="ordered" />:
        </Field>
        <Value>{orderDate}</Value>
      </Flex>
      {shipmentNumber && (
        <Flex>
          <Field>
            <I18n name="shipment" />:
          </Field>
          <Value>{shipmentNumber}</Value>
        </Flex>
      )}
      <Flex>
        <Field>
          <I18n name="shippingId" />:
        </Field>
        <Value>{shippingId}</Value>
      </Flex>
    </Wrapper>
  )
}

const Flex = styled.div`
  display: flex;
`

const Wrapper = styled(Flex)`
  font-size: 14px;
  flex-direction: column;
  margin-bottom: 0.5rem;
  gap: 0.1rem;
`

const Field = styled.span`
  font-weight: bold;
`

const Value = styled.span`
  padding-left: 0.2rem;
`

export default CommonStepInfo
